// tslint:disable
// @ts-nocheck
/**
 * Enter API Documentation
 * ## Interactive Documentation ##### Our API documentation allows you to test API calls straight from this website. ##### To do this, scroll down a little and click the green \"Authorize\" button (with a padlock) to the right and below. A pop-up should appear. ##### In the popup, enter your \"client_id\" and \"client_secret\" values (these will be provided to you) and press \"Authorize\". You should now be logged in (you can open up your network tab to see the API traffic going through). ##### From here, you can click any endpoint below to expand its details and click the \"Try it out\" button that appears in the expanded section. ##### Fill out the parameter fields and then click \"Execute\" to call the endpoint. The results of your query should be shown below. ## Authentication ##### Our API uses the OAuth 2.0 Client Credentials flow to authorize clients. ##### With your provided \"Client Id\" and \"Client Secret\", make the following call: ``` POST /oauth/token HTTP/1.1 Host: api.enter.health  grant_type=client_credentials &client_id=XXXXXXXXXXXX &client_secret=YYYYYYYYYYY ``` ##### Here\'s an example CURL request: ``` curl \'https://api.enter.health/oauth/token\' -H \'accept: application/json\' --data \'grant_type=client_credentials&client_id=XXXXXXXXXXXX&client_secret=YYYYYYYYYYY\' ``` ##### The response should look something like this ``` {   \"access_token\" : \"AAAAAAAAAAAAAAAAAAA\",   \"refresh_token\" : \"BBBBBBBBBBBBBBBBBBB\" }  ``` ##### With the access token provided, you can make an authenticated call to any of the endpoints below by including the header \"Authorization: Bearer AAAAAAAAAAAAAAAAAAA\" with your API request. ##### Here\'s an example of a basic curl request to the \"/me\" endpoint ``` curl \'https://api.enter.health/me\' -H \'accept: application/json\' -H \'authorization: Bearer AAAAAAAAAAAAAAAAAAA\' ``` ##### Note that access tokens are not long-living tokens. The lifetime of them differs from client to client, but they may last as short as 15 minutes (if you would like an increase in time, please reach out to us). ### Comparators ##### Filter parameters need to be formatted with a comparator and value in the format of \"COMPARATOR:VALUE\". The following is a list of possible values:  ##### GTE - Greater than or equal ##### GT - Greater than ##### LT - Less Than ##### LTE - Less than or equal ##### EQ - Equal ##### NQ - Not Equal ##### LK - Like ##### NLK - Not Like ##### EMPTY - Is null ##### NEMPTY - Is not null ## Subject to Change ##### Note that this API is in active development and may be subject to changes at any time. ##### This document is a living document with current specifications. If your integration does not seem to work properly, please refer back to this page to look for updates. ##### If you are still having issues, please reach out to support. 
 *
 * The version of the OpenAPI document: 2
 * Contact: support@enter.health
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    Amount,
    AmountFromJSON,
    AmountToJSON,
    ClaimCloseoutType,
    ClaimCloseoutTypeFromJSON,
    ClaimCloseoutTypeToJSON,
    ClaimResponsibilityType,
    ClaimResponsibilityTypeFromJSON,
    ClaimResponsibilityTypeToJSON,
    ClaimTransmissionStatusType,
    ClaimTransmissionStatusTypeFromJSON,
    ClaimTransmissionStatusTypeToJSON,
    ClaimType,
    ClaimTypeFromJSON,
    ClaimTypeToJSON,
    SupportClaimResponsibilityCategoryType,
    SupportClaimResponsibilityCategoryTypeFromJSON,
    SupportClaimResponsibilityCategoryTypeToJSON,
    SupportCollectionStatusType,
    SupportCollectionStatusTypeFromJSON,
    SupportCollectionStatusTypeToJSON,
    SupportCollectionStrategyType,
    SupportCollectionStrategyTypeFromJSON,
    SupportCollectionStrategyTypeToJSON,
    Tags,
    TagsFromJSON,
    TagsToJSON,
} from './';

/**
 * 
 * @export
 * @interface SupportClaim
 */
export interface SupportClaim extends Tags {
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    id?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    guarantorId?: string;
    /**
     * 
     * OpenAPI data type: {SupportCollectionStatusType}
     * @type {SupportCollectionStatusType}
     * @memberof SupportClaim
     */
    collectionStatus?: SupportCollectionStatusType;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    collectionStatusDetails?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    collectionMemo?: string;
    /**
     * 
     * OpenAPI data type: {SupportCollectionStrategyType}
     * @type {SupportCollectionStrategyType}
     * @memberof SupportClaim
     */
    collectionStrategy?: SupportCollectionStrategyType;
    /**
     * 
     * OpenAPI data type: {ClaimResponsibilityType}
     * @type {ClaimResponsibilityType}
     * @memberof SupportClaim
     */
    claimResponsibilityType?: ClaimResponsibilityType;
    /**
     * 
     * OpenAPI data type: {SupportClaimResponsibilityCategoryType}
     * @type {SupportClaimResponsibilityCategoryType}
     * @memberof SupportClaim
     */
    claimResponsibilityCategoryType?: SupportClaimResponsibilityCategoryType;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    claimResponsibilityEventDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    claimResponsibilityCheckedDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    claimAdjudicationDate?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    claimCollectionsDate?: string;
    /**
     * Errors that occurred while validating the claim
     * OpenAPI data type: {array}
     * @type {Array<string>}
     * @memberof SupportClaim
     */
    claimValidationErrors?: Array<string>;
    /**
     * Whether the validation process on the claim has been run
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClaim
     */
    claimValidated?: boolean;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    claimValidationCheckedDate?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportClaim
     */
    maximumGuarantorResponsibility?: Amount;
    /**
     * The visit account number from the claim.  This typically comes from the EMR.
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    accountNumber?: string;
    /**
     * The from date of service of the latest claim
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    fromDos?: string;
    /**
     * The through date of service of the latest claim
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    throughDos?: string;
    /**
     * The guarantor first name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    guarantorFirst?: string;
    /**
     * The guarantor last name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    guarantorLast?: string;
    /**
     * The patient id from the external system
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    patientExternalId?: string;
    /**
     * The patient nickname
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    patientNickname?: string;
    /**
     * The patient first name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    patientFirst?: string;
    /**
     * The patient last name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    patientLast?: string;
    /**
     * Individual suffix
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    patientSuffix?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    patientId?: string;
    /**
     * The date of birth
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    patientDob?: string;
    /**
     * The primary third party administrator name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    primaryThirdPartyAdministratorName?: string;
    /**
     * The secondary third party administrator name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    secondaryThirdPartyAdministratorName?: string;
    /**
     * The tertiary third party administrator name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    tertiaryThirdPartyAdministratorName?: string;
    /**
     * The primary payer name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    primaryPayerName?: string;
    /**
     * The secondary payer name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    secondaryPayerName?: string;
    /**
     * The secondary payer name
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    tertiaryPayerName?: string;
    /**
     * The primary payer subscriber member id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    primaryPayerSubscriberMemberId?: string;
    /**
     * The secondary payer subscriber member id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    secondaryPayerSubscriberMemberId?: string;
    /**
     * The tertiary payer subscriber member id
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    tertiaryPayerSubscriberMemberId?: string;
    /**
     * 
     * OpenAPI data type: {ClaimTransmissionStatusType}
     * @type {ClaimTransmissionStatusType}
     * @memberof SupportClaim
     */
    transmissionStatus?: ClaimTransmissionStatusType;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportClaim
     */
    chargeAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportClaim
     */
    allowedAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportClaim
     */
    payerAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportClaim
     */
    patientAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportClaim
     */
    chargemasterAllowedAmount?: Amount;
    /**
     * Number of payer payments
     * OpenAPI data type: {integer}
     * @type {number}
     * @memberof SupportClaim
     */
    payments?: number;
    /**
     * The last time the claim was transmitted
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    latestSubmittedDate?: string;
    /**
     * The last payment received date
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    latestPaymentDate?: string;
    /**
     * The patient invoice
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    patientInvoiceId?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    patientInvoicePaymentUrl?: string;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportClaim
     */
    patientInvoiceAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportClaim
     */
    patientInvoicePaidAmount?: Amount;
    /**
     * 
     * OpenAPI data type: {Amount}
     * @type {Amount}
     * @memberof SupportClaim
     */
    patientPrepaidAmount?: Amount;
    /**
     * Paperwork required on this claim
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClaim
     */
    paperwork?: boolean;
    /**
     * The claim bundle group
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    claimBundleId?: string;
    /**
     * 
     * OpenAPI data type: {ClaimType}
     * @type {ClaimType}
     * @memberof SupportClaim
     */
    type?: ClaimType;
    /**
     * 
     * OpenAPI data type: {ClaimCloseoutType}
     * @type {ClaimCloseoutType}
     * @memberof SupportClaim
     */
    closeoutType?: ClaimCloseoutType;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    closeoutDescription?: string;
    /**
     * 
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClaim
     */
    closeoutVoid?: boolean;
    /**
     * The status of the claim
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClaim
     */
    active?: boolean;
    /**
     * User markable as starred
     * OpenAPI data type: {boolean}
     * @type {boolean}
     * @memberof SupportClaim
     */
    starred?: boolean;
    /**
     * The user id of who created the resource
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    createdBy?: string;
    /**
     * 
     * OpenAPI data type: {string}
     * @type {Date}
     * @memberof SupportClaim
     */
    created?: string;
    /**
     * The workflow status that claim is currently at
     * OpenAPI data type: {string}
     * @type {string}
     * @memberof SupportClaim
     */
    workflowStatus?: string;
}

export function SupportClaimFromJSON(json: any): SupportClaim {
    return {
                'id': !exists(json, 'id') ? undefined : json['id'],
                'guarantorId': !exists(json, 'guarantorId') ? undefined : json['guarantorId'],
                'collectionStatus': !exists(json, 'collectionStatus') ? undefined : SupportCollectionStatusTypeFromJSON(json['collectionStatus']),
                'collectionStatusDetails': !exists(json, 'collectionStatusDetails') ? undefined : json['collectionStatusDetails'],
                'collectionMemo': !exists(json, 'collectionMemo') ? undefined : json['collectionMemo'],
                'collectionStrategy': !exists(json, 'collectionStrategy') ? undefined : SupportCollectionStrategyTypeFromJSON(json['collectionStrategy']),
                'claimResponsibilityType': !exists(json, 'claimResponsibilityType') ? undefined : ClaimResponsibilityTypeFromJSON(json['claimResponsibilityType']),
                'claimResponsibilityCategoryType': !exists(json, 'claimResponsibilityCategoryType') ? undefined : SupportClaimResponsibilityCategoryTypeFromJSON(json['claimResponsibilityCategoryType']),
                'claimResponsibilityEventDate': !exists(json, 'claimResponsibilityEventDate') ? undefined : json['claimResponsibilityEventDate'],
                'claimResponsibilityCheckedDate': !exists(json, 'claimResponsibilityCheckedDate') ? undefined : json['claimResponsibilityCheckedDate'],
                'claimAdjudicationDate': !exists(json, 'claimAdjudicationDate') ? undefined : json['claimAdjudicationDate'],
                'claimCollectionsDate': !exists(json, 'claimCollectionsDate') ? undefined : json['claimCollectionsDate'],
                'claimValidationErrors': !exists(json, 'claimValidationErrors') ? undefined : json['claimValidationErrors'],
                'claimValidated': !exists(json, 'claimValidated') ? undefined : json['claimValidated'],
                'claimValidationCheckedDate': !exists(json, 'claimValidationCheckedDate') ? undefined : json['claimValidationCheckedDate'],
                'maximumGuarantorResponsibility': !exists(json, 'maximumGuarantorResponsibility') ? undefined : AmountFromJSON(json['maximumGuarantorResponsibility']),
                'accountNumber': !exists(json, 'accountNumber') ? undefined : json['accountNumber'],
                'fromDos': !exists(json, 'fromDos') ? undefined : json['fromDos'],
                'throughDos': !exists(json, 'throughDos') ? undefined : json['throughDos'],
                'guarantorFirst': !exists(json, 'guarantorFirst') ? undefined : json['guarantorFirst'],
                'guarantorLast': !exists(json, 'guarantorLast') ? undefined : json['guarantorLast'],
                'patientExternalId': !exists(json, 'patientExternalId') ? undefined : json['patientExternalId'],
                'patientNickname': !exists(json, 'patientNickname') ? undefined : json['patientNickname'],
                'patientFirst': !exists(json, 'patientFirst') ? undefined : json['patientFirst'],
                'patientLast': !exists(json, 'patientLast') ? undefined : json['patientLast'],
                'patientSuffix': !exists(json, 'patientSuffix') ? undefined : json['patientSuffix'],
                'patientId': !exists(json, 'patientId') ? undefined : json['patientId'],
                'patientDob': !exists(json, 'patientDob') ? undefined : json['patientDob'],
                'primaryThirdPartyAdministratorName': !exists(json, 'primaryThirdPartyAdministratorName') ? undefined : json['primaryThirdPartyAdministratorName'],
                'secondaryThirdPartyAdministratorName': !exists(json, 'secondaryThirdPartyAdministratorName') ? undefined : json['secondaryThirdPartyAdministratorName'],
                'tertiaryThirdPartyAdministratorName': !exists(json, 'tertiaryThirdPartyAdministratorName') ? undefined : json['tertiaryThirdPartyAdministratorName'],
                'primaryPayerName': !exists(json, 'primaryPayerName') ? undefined : json['primaryPayerName'],
                'secondaryPayerName': !exists(json, 'secondaryPayerName') ? undefined : json['secondaryPayerName'],
                'tertiaryPayerName': !exists(json, 'tertiaryPayerName') ? undefined : json['tertiaryPayerName'],
                'primaryPayerSubscriberMemberId': !exists(json, 'primaryPayerSubscriberMemberId') ? undefined : json['primaryPayerSubscriberMemberId'],
                'secondaryPayerSubscriberMemberId': !exists(json, 'secondaryPayerSubscriberMemberId') ? undefined : json['secondaryPayerSubscriberMemberId'],
                'tertiaryPayerSubscriberMemberId': !exists(json, 'tertiaryPayerSubscriberMemberId') ? undefined : json['tertiaryPayerSubscriberMemberId'],
                'transmissionStatus': !exists(json, 'transmissionStatus') ? undefined : ClaimTransmissionStatusTypeFromJSON(json['transmissionStatus']),
                'chargeAmount': !exists(json, 'chargeAmount') ? undefined : AmountFromJSON(json['chargeAmount']),
                'allowedAmount': !exists(json, 'allowedAmount') ? undefined : AmountFromJSON(json['allowedAmount']),
                'payerAmount': !exists(json, 'payerAmount') ? undefined : AmountFromJSON(json['payerAmount']),
                'patientAmount': !exists(json, 'patientAmount') ? undefined : AmountFromJSON(json['patientAmount']),
                'chargemasterAllowedAmount': !exists(json, 'chargemasterAllowedAmount') ? undefined : AmountFromJSON(json['chargemasterAllowedAmount']),
                'payments': !exists(json, 'payments') ? undefined : json['payments'],
                'latestSubmittedDate': !exists(json, 'latestSubmittedDate') ? undefined : json['latestSubmittedDate'],
                'latestPaymentDate': !exists(json, 'latestPaymentDate') ? undefined : json['latestPaymentDate'],
                'patientInvoiceId': !exists(json, 'patientInvoiceId') ? undefined : json['patientInvoiceId'],
                'patientInvoicePaymentUrl': !exists(json, 'patientInvoicePaymentUrl') ? undefined : json['patientInvoicePaymentUrl'],
                'patientInvoiceAmount': !exists(json, 'patientInvoiceAmount') ? undefined : AmountFromJSON(json['patientInvoiceAmount']),
                'patientInvoicePaidAmount': !exists(json, 'patientInvoicePaidAmount') ? undefined : AmountFromJSON(json['patientInvoicePaidAmount']),
                'patientPrepaidAmount': !exists(json, 'patientPrepaidAmount') ? undefined : AmountFromJSON(json['patientPrepaidAmount']),
                'paperwork': !exists(json, 'paperwork') ? undefined : json['paperwork'],
                'claimBundleId': !exists(json, 'claimBundleId') ? undefined : json['claimBundleId'],
                'type': !exists(json, 'type') ? undefined : ClaimTypeFromJSON(json['type']),
                'closeoutType': !exists(json, 'closeoutType') ? undefined : ClaimCloseoutTypeFromJSON(json['closeoutType']),
                'closeoutDescription': !exists(json, 'closeoutDescription') ? undefined : json['closeoutDescription'],
                'closeoutVoid': !exists(json, 'closeoutVoid') ? undefined : json['closeoutVoid'],
                'active': !exists(json, 'active') ? undefined : json['active'],
                'starred': !exists(json, 'starred') ? undefined : json['starred'],
                'createdBy': !exists(json, 'createdBy') ? undefined : json['createdBy'],
                'created': !exists(json, 'created') ? undefined : json['created'],
                'workflowStatus': !exists(json, 'workflowStatus') ? undefined : json['workflowStatus'],
        ...TagsFromJSON(json)
    };

}

export function SupportClaimToForm(value?: SupportClaim): any {
    let jsonVal = SupportClaimToJSON(value);
    let retVal = '';
    if(jsonVal !== undefined && jsonVal != null) {
        Object.keys(jsonVal).forEach((v, i) => {
            if(i > 0) retVal+= "&";
            retVal+= encodeURIComponent(v) + "=" + encodeURIComponent(jsonVal[v]);
        });
    }
    return retVal;
}

function cleanupBlankValuesForBackend(val?:any): any {
    if(val instanceof Array) {
        return (val as Array<any>).filter((val) => { return val !== undefined && val !== null && val !== ''});
    } else {
        return (val === '') ? null : val;
    }
}

export function SupportClaimToJSON(value?: SupportClaim): any {
    value = cleanupBlankValuesForBackend(value);
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
            'id': cleanupBlankValuesForBackend(value.id),
            'guarantorId': cleanupBlankValuesForBackend(value.guarantorId),
            'collectionStatus': SupportCollectionStatusTypeToJSON(value.collectionStatus),
            'collectionStatusDetails': cleanupBlankValuesForBackend(value.collectionStatusDetails),
            'collectionMemo': cleanupBlankValuesForBackend(value.collectionMemo),
            'collectionStrategy': SupportCollectionStrategyTypeToJSON(value.collectionStrategy),
            'claimResponsibilityType': ClaimResponsibilityTypeToJSON(value.claimResponsibilityType),
            'claimResponsibilityCategoryType': SupportClaimResponsibilityCategoryTypeToJSON(value.claimResponsibilityCategoryType),
            'claimResponsibilityEventDate': cleanupBlankValuesForBackend(value.claimResponsibilityEventDate),
            'claimResponsibilityCheckedDate': cleanupBlankValuesForBackend(value.claimResponsibilityCheckedDate),
            'claimAdjudicationDate': cleanupBlankValuesForBackend(value.claimAdjudicationDate),
            'claimCollectionsDate': cleanupBlankValuesForBackend(value.claimCollectionsDate),
            'claimValidationErrors': cleanupBlankValuesForBackend(value.claimValidationErrors),
            'claimValidated': cleanupBlankValuesForBackend(value.claimValidated),
            'claimValidationCheckedDate': cleanupBlankValuesForBackend(value.claimValidationCheckedDate),
            'maximumGuarantorResponsibility': AmountToJSON(value.maximumGuarantorResponsibility),
            'accountNumber': cleanupBlankValuesForBackend(value.accountNumber),
            'fromDos': cleanupBlankValuesForBackend(value.fromDos),
            'throughDos': cleanupBlankValuesForBackend(value.throughDos),
            'guarantorFirst': cleanupBlankValuesForBackend(value.guarantorFirst),
            'guarantorLast': cleanupBlankValuesForBackend(value.guarantorLast),
            'patientExternalId': cleanupBlankValuesForBackend(value.patientExternalId),
            'patientNickname': cleanupBlankValuesForBackend(value.patientNickname),
            'patientFirst': cleanupBlankValuesForBackend(value.patientFirst),
            'patientLast': cleanupBlankValuesForBackend(value.patientLast),
            'patientSuffix': cleanupBlankValuesForBackend(value.patientSuffix),
            'patientId': cleanupBlankValuesForBackend(value.patientId),
            'patientDob': cleanupBlankValuesForBackend(value.patientDob),
            'primaryThirdPartyAdministratorName': cleanupBlankValuesForBackend(value.primaryThirdPartyAdministratorName),
            'secondaryThirdPartyAdministratorName': cleanupBlankValuesForBackend(value.secondaryThirdPartyAdministratorName),
            'tertiaryThirdPartyAdministratorName': cleanupBlankValuesForBackend(value.tertiaryThirdPartyAdministratorName),
            'primaryPayerName': cleanupBlankValuesForBackend(value.primaryPayerName),
            'secondaryPayerName': cleanupBlankValuesForBackend(value.secondaryPayerName),
            'tertiaryPayerName': cleanupBlankValuesForBackend(value.tertiaryPayerName),
            'primaryPayerSubscriberMemberId': cleanupBlankValuesForBackend(value.primaryPayerSubscriberMemberId),
            'secondaryPayerSubscriberMemberId': cleanupBlankValuesForBackend(value.secondaryPayerSubscriberMemberId),
            'tertiaryPayerSubscriberMemberId': cleanupBlankValuesForBackend(value.tertiaryPayerSubscriberMemberId),
            'transmissionStatus': ClaimTransmissionStatusTypeToJSON(value.transmissionStatus),
            'chargeAmount': AmountToJSON(value.chargeAmount),
            'allowedAmount': AmountToJSON(value.allowedAmount),
            'payerAmount': AmountToJSON(value.payerAmount),
            'patientAmount': AmountToJSON(value.patientAmount),
            'chargemasterAllowedAmount': AmountToJSON(value.chargemasterAllowedAmount),
            'payments': cleanupBlankValuesForBackend(value.payments),
            'latestSubmittedDate': cleanupBlankValuesForBackend(value.latestSubmittedDate),
            'latestPaymentDate': cleanupBlankValuesForBackend(value.latestPaymentDate),
            'patientInvoiceId': cleanupBlankValuesForBackend(value.patientInvoiceId),
            'patientInvoicePaymentUrl': cleanupBlankValuesForBackend(value.patientInvoicePaymentUrl),
            'patientInvoiceAmount': AmountToJSON(value.patientInvoiceAmount),
            'patientInvoicePaidAmount': AmountToJSON(value.patientInvoicePaidAmount),
            'patientPrepaidAmount': AmountToJSON(value.patientPrepaidAmount),
            'paperwork': cleanupBlankValuesForBackend(value.paperwork),
            'claimBundleId': cleanupBlankValuesForBackend(value.claimBundleId),
            'type': ClaimTypeToJSON(value.type),
            'closeoutType': ClaimCloseoutTypeToJSON(value.closeoutType),
            'closeoutDescription': cleanupBlankValuesForBackend(value.closeoutDescription),
            'closeoutVoid': cleanupBlankValuesForBackend(value.closeoutVoid),
            'active': cleanupBlankValuesForBackend(value.active),
            'starred': cleanupBlankValuesForBackend(value.starred),
            'createdBy': cleanupBlankValuesForBackend(value.createdBy),
            'created': cleanupBlankValuesForBackend(value.created),
            'workflowStatus': cleanupBlankValuesForBackend(value.workflowStatus),
            ...TagsToJSON(value)
    };
}


